import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=b47c8460&"
import script from "./MainFooter.vue?vue&type=script&lang=js&"
export * from "./MainFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b47c8460')) {
      api.createRecord('b47c8460', component.options)
    } else {
      api.reload('b47c8460', component.options)
    }
    module.hot.accept("./MainFooter.vue?vue&type=template&id=b47c8460&", function () {
      api.rerender('b47c8460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/MainFooter.vue"
export default component.exports